import styled from "styled-components";
import { device } from "../device";

export interface ContentProps {
    cols: number;
    largeHeadline?: boolean;
}

export const ContentContainer = styled.div<ContentProps>`
    display: grid;
    grid-template-columns: repeat(${(props) => props.cols}, minmax(0, 1fr));
    height: auto;
    width: 100%;
    padding: 24px;

    @media ${device.tablet} {
        padding: 32px;
    }

    .container-headline {
        margin-bottom: 12px;
        width: 100%;
    }

    strong {
        font-size: ${(props) => props.largeHeadline ? "23px" : "20px"};
        line-height: ${(props) => props.largeHeadline ? "30px" : "27px"};
        text-shadow: ${(props) => props.largeHeadline ? "1px 0 #202b57;" : "none"};
        letter-spacing: -0.03em;
        font-weight: 700;
        margin-top: 0;
    }

    p {
        font-weight: normal;
        font-size: 18px;
        line-height: 25px;
        margin: 0;
    }
`;

export const ProfileTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;

    .form-message-wrapper {
        display: block;
        margin-top: 8px;
    }
    p {
        margin-top: 10px;
        margin-bottom: 20px;
    }
`;

export const ProfileTextContainerLargeText = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    max-width: 950px;
    padding: 32px;

    span {
        font-size: 17px;
        line-height: 145%;
    }

    .form-message-wrapper {
        display: block;
        margin-top: 8px;
    }
    p {
        margin-top: 10px;
        margin-bottom: 20px;
    }
`;

export const ReadOnlyContainer = styled.div`
    width: 100%;
    label {
        margin: 0;
        font-size: 12px;
        line-height: 16px;
        color: #6E6E73;
        letter-spacing: -0.01em;
    }
    p {
        margin: 0;
        font-size: 17px;
        line-height: 25px;
    }
`;

export const ReadElement = styled.div`
    display: block;
    flex: 1;
`;

export const FlexRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;

export const InputRowSingle = styled.div`
    width: 100%;
    margin-bottom: 10px;
`;
export const InputRowDual = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    grid-column-gap: 20px;
    width: 100%;
    align-items: flex-start;
    margin-bottom: 10px;
`;